import React, { useState } from 'react'
import './App.css'
import './styles/global.css'
import './styles/coreui-overrides.css'
import './styles/carousel.css'
import './styles/charts.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './chartSetup'
import { AuthProvider } from './context/AuthContext'
import { ThemeProvider } from './utils/theme'
import LoginPage from './pages/LoginPage'
import AppLayout from './components/AppLayout'
import '@coreui/coreui/dist/css/coreui.min.css'

function App() {
  const [compareMode, setCompareMode] = useState(false)
  const [compareCountries, setCompareCountries] = useState([])

  return (
    <ThemeProvider>
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            {/* AppLayout renders the header + footer on every page, the
                sidebar only on app pages, and gates the app pages behind
                ProtectedRoute itself. */}
            <Route
              path="/*"
              element={
                <AppLayout
                  compareMode={compareMode}
                  setCompareMode={setCompareMode}
                  compareCountries={compareCountries}
                  setCompareCountries={setCompareCountries}
                />
              }
            />
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  )
}

export default App
